module.exports = __webpack_public_path__ + "static/media/more-all-products-6.c5dd0042.png";